"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarDateToString = exports.stringToCalendarDate = exports.formatDateTime24hr = exports.formatDate = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const date_1 = require("@internationalized/date");
function formatDate(dateString) {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year.toString()}`;
}
exports.formatDate = formatDate;
/**
 * Formats a date/time string in 24-hour format
 * @param date - Date string or Date object to format
 * @returns Formatted string like "12 Jan 2025, 15:53" or "N/A" if invalid
 */
function formatDateTime24hr(date) {
    if (!date)
        return "N/A";
    const d = new Date(date);
    if (isNaN(d.getTime()))
        return "N/A";
    const dateStr = doshx_controls_web_1.Utilities.formatDateTime(date).split(',')[0]; // Get date part only
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${dateStr}, ${hours}:${minutes}`;
}
exports.formatDateTime24hr = formatDateTime24hr;
/**
 * Converts a date string (YYYY-MM-DD) to a CalendarDate for HeroUI DateInput.
 * Returns null if the string is empty or malformed (e.g. 6-digit year from
 * legacy data) — the DateInput renders empty so the user can re-enter.
 */
function stringToCalendarDate(value) {
    if (!value)
        return null;
    const parts = value.split("-");
    if (parts.length !== 3)
        return null;
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);
    if (isNaN(year) || isNaN(month) || isNaN(day))
        return null;
    if (year < 1 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31)
        return null;
    // Reject impossible dates (e.g. Feb 31) — Date normalises them,
    // so compare the resulting day against the input day.
    // Use setFullYear to avoid JS treating years 0-99 as 1900+year.
    const probe = new Date(0);
    probe.setFullYear(year, month - 1, day);
    if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) {
        return null;
    }
    return new date_1.CalendarDate(year, month, day);
}
exports.stringToCalendarDate = stringToCalendarDate;
/**
 * Converts a CalendarDate back to a YYYY-MM-DD string for storage.
 */
function calendarDateToString(date) {
    if (!date)
        return "";
    const year = date.year.toString().padStart(4, "0");
    const month = date.month.toString().padStart(2, "0");
    const day = date.day.toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
}
exports.calendarDateToString = calendarDateToString;
